import mascot_ko from './videos/mascot_ko.mp4'
import mascot_en from './videos/mascot_en.mp4'
import mascot_es from './videos/mascot_es.mp4'
import mascot_fr from './videos/mascot_fr.mp4'

const data = [
  {
    label: { ko: '한국어', en: 'Korean' },
    url: {
      ko: mascot_ko,
      en: mascot_ko,
    },
  },
  {
    label: { ko: '영어', en: 'English' },
    url: {
      ko: mascot_en,
      en: mascot_en,
    },
  },
  {
    label: { ko: '스페인어', en: 'Spanish' },
    url: {
      ko: mascot_es,
      en: mascot_es,
    },
  },
  {
    label: { ko: '프랑스어', en: 'French' },
    url: {
      ko: mascot_fr,
      en: mascot_fr,
    },
  },
]

export default data
